import { IPaginationResourceShort } from '../../../props/general';
import { IOrderPriceUpdateResourceShortProps } from '../../../props/orders/priceUpdates';
import Request from './../../request';

// import props

const OrderPriceUpdateService = {
    retrieve: async (qs?: string): Promise<{ data: IOrderPriceUpdateResourceShortProps[], pagination?: IPaginationResourceShort }> => {
        try {
            const result = await Request.get(`/api/orders/pricings/updates?${qs || ""}`);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    get: async (id: string): Promise<IOrderPriceUpdateResourceShortProps> => {
        try {
            const result = await Request.get(`/api/orders/pricings/updates/${id}`);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    reject: async (id: string, data: FormData): Promise<IOrderPriceUpdateResourceShortProps> => {
        try {
            const result = await Request.post(`/api/orders/pricings/updates/${id}/reject`, data);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    approve: async (id: string, data: FormData): Promise<IOrderPriceUpdateResourceShortProps> => {
        try {
            const result = await Request.post(`/api/orders/pricings/updates/${id}/approve`, data);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    create: async (data: FormData): Promise<IOrderPriceUpdateResourceShortProps> => {
        try {
            const result = await Request.post(`/api/orders/pricings/updates`, data, 'multipart/form-data');
            return result;
        } catch (e) {
            throw (e);
        }
    }
}

export default OrderPriceUpdateService;